import CollectionList   from '@/js/Shared/Collections/CollectionList.js';
import CollectionSearch from '@/js/Shared/Collections/CollectionSearch.js';
import SmokecreenItem   from '../Entities/SmokecreenItem.js';

export { SmokescreenCollectionList as default };

/**
* Smokescreen Collection List
*
* @author      Rúben Simões <ruben.r.simoes@meo.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class SmokescreenCollectionList extends CollectionList
{
    search_list = new CollectionSearch('address');

    constructor(index_id) {
        super(index_id);
        this.search_list.setSearchList(this);
    }

    /**
     * Retrieves an address from from the smokescreen by address
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {String} address
     *
     * @return {SmokescreenItem}
     */
    get(address) {
        return this.index[address] || new SmokecreenItem();
    }

    /**
     * Resorts all addresses by alphabetical order
     *
     * @public
     *
     * @since 7.0.0
     *
     * @return {void}
     */
    resortItems() {
        this.items.sort((a,b) => {
        return a.address.localeCompare(b.address, undefined, { numeric: true });
        })
    }

    search(term) {
        this.search_list.term = term;
        this.search_list.search(term, {
            address: ['lower_case', 'latinize'],
        })
    }
}